import React from "react";

import styled from "styled-components/macro";

import unoPiggyBank from "Payments/FundItPage/images/uno-piggy-bank.png";

import FnrVerticalCarousel from "UI/FnrVerticalCarousel";

export default function TitleSection() {
  const carouselItems = [
    "It!",
    "youth trips",
    "retreats",
    "pizza nights",
    "Sunday donuts",
    "annual picnics",
    "VBS",
    "bake sales",
    "building costs",
    "your church",
    "mission trips",
    "construction",
    "annual appeals",
  ];

  return (
    <Top>
      <PiggyBankImage />
      <TitleWrapper>
        <Title>
          {/* <FundSpan>Fund&nbsp;</FundSpan>
          <FnrVerticalCarousel items={carouselItems} random /> */}
          <FundSpan>Online &amp; Mobile Giving</FundSpan>
        </Title>

        <TitleDescription>
          <SmallPiggyBankImage />
          <div>
            {/* Now you can collect payments for tithing, donations, ministry
            funding, events, & more.
            <Whatever>
              Whatever <It>it</It> is, Fund it with Flocknote!
            </Whatever> */}
            Secure payment processing is included with all Flocknote plans.
            Perfect for tithing, donations, ministry funding, events, retreats,
            and more!
          </div>
        </TitleDescription>
      </TitleWrapper>
    </Top>
  );
}

const Top = styled.div`
  display: flex;
  align-items: stretch;
  padding: 40px 30px;
  gap: 20px;
  @media screen and (max-width: 590px) {
    padding: 30px 20px;
  }
  @media screen and (max-width: 400px) {
    flex-direction: column;
  }
`;

const TitleWrapper = styled.div`
  flex: 1;
`;

const PiggyBankImage = styled.div`
  opacity: 0.8;
  flex-grow: 0;
  flex-shrink: 0;
  background-image: url(${unoPiggyBank});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
  width: 70px;
  min-height: 70px;

  @media screen and (min-width: 841px) and (max-width: 930px),
    screen and (min-width: 400px) and (max-width: 590px) {
    display: none;
  }
`;
const SmallPiggyBankImage = styled(PiggyBankImage)`
  width: 60px;
  display: block;
  @media screen and (min-width: 590px), screen and (max-width: 400px) {
    display: none;
  }
`;

const Title = styled.div`
  font-style: italic;
  /* font-size: 40px; */
  font-size: 38px;
  font-weight: bold;
  line-height: 1;
  display: flex;
  padding-bottom: 8px;
  overflow-y: hidden;
  @media (max-width: 460px) {
    font-size: 32px;
  }
  @media (max-width: 380px) {
    font-size: 28px;
  }
  @media (max-width: 340px) {
    font-size: 26px;
  }
`;

const FundSpan = styled.div`
  font-weight: 100;
`;

const TitleDescription = styled.div`
  font-size: 20px;
  color: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: stretch;
  gap: 20px;
  line-height: 1.2;
  @media screen and (max-width: 590px) {
    font-size: 16px;
  }
`;
